import { render, staticRenderFns } from "./distribution-install-orders.vue?vue&type=template&id=7321bdf5&scoped=true"
import script from "./distribution-install-orders.vue?vue&type=script&lang=js"
export * from "./distribution-install-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7321bdf5",
  null
  
)

export default component.exports